import React, { useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { AuthContext } from "../../../Context/AuthContext";

export default function TabMandate({ value, setValue }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
      >
        <Tab value="AllMandate" label={t("thead_mandate")} />
        <Tab value="User" label={t("thead_user")} />
      </Tabs>
    </Box>
  );
}
